import Tutorials from "../../../Components/JpegXLSupport/Tutorials/Tutorials";
import React from "react";

function RelatedT(props) {
    return(
        <>
            <p className='search_heading'>Related Articles</p>
            <div className='related_articles'>
                {props.related.map((tutorial, index) => (
                    <Tutorials key={index} href={tutorial.href} name={tutorial.name} side={tutorial.side}
                               text={tutorial.text}/>
                ))}
            </div>
        </>
    )
}

export default RelatedT